import eventQueue from '../queue';
function attachEventListeners() {
    eventQueue.on('select_account', function (_a) {
        var fireClientEvent = _a.fireClientEvent, data = _a.data;
        fireClientEvent('other_event', {
            name: 'select_account',
            payload: [
                {
                    key: 'id',
                    value: data.id,
                    type: 'string',
                },
                {
                    key: 'accountName',
                    value: data.accountName,
                    type: 'string',
                },
                {
                    key: 'accountNumberLastFour',
                    value: data.accountNumberLastFour,
                    type: 'string',
                },
                {
                    key: 'accountType',
                    value: data.accountType,
                    type: 'string',
                },
            ],
        });
    });
}
attachEventListeners();
